import { CheckCircle } from 'lucide-react'
import { AuthLayout } from '@/modules/auth/ui/components'
import { AppStoreBadges } from '@/shared/ui/components'

export type ProNotNowStateProps = {
  inApp: boolean
}

export function ProNotNowState({ inApp }: ProNotNowStateProps) {
  return (
    <AuthLayout title="You're all set" subtitle="You have BlindBook Pro.">
      <div className="flex flex-col items-center gap-4 text-center" data-testid="pro-not-now-state">
        <CheckCircle className="size-12 text-primary" aria-hidden />
        <p className="text-sm text-muted-foreground">
          {inApp
            ? 'Tap ✕ to go back to the app. Add Waterfowl U from the app anytime.'
            : 'Open the BlindBook app, or download it, and sign in with your email. Add Waterfowl U from the app anytime.'}
        </p>
        {inApp ? null : (
          <div className="pt-2">
            <AppStoreBadges />
          </div>
        )}
      </div>
    </AuthLayout>
  )
}
